import React from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import SiteConfigComponent from '../config/SiteConfigComponent';
import SiteConfigDeleteComponent from '../config/SiteConfigDeleteComponent';
import { useSiteContext } from '../SiteContext';
const StyledDiv = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 12px;
  overflow-y: auto;
  .config-zero-state {
    padding: 12px;
    text-align: center;
    color: #999;
  }
  .divider {
    margin: 12px -12px;
    border-top: solid 1px #ccc;
  }
  .bottom {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    flex: 1;
    width: 100%;
    margin-top: 8px;
  }
`;
const SiteConfigurePanel = () => {
    const { configureComponent, plugins } = useSiteContext();
    const plugin = plugins.find(p => p.type === (configureComponent === null || configureComponent === void 0 ? void 0 : configureComponent.type));
    return (React.createElement(StyledDiv, { className: 'site-configure' }, configureComponent ? (React.createElement(React.Fragment, null,
        React.createElement(SiteConfigComponent, { component: configureComponent }),
        React.createElement("div", { className: 'divider' }),
        plugin ? (plugin.configurator ? (React.createElement(plugin.configurator, { component: configureComponent })) : (React.createElement(Alert, { severity: 'info' }, "No configuration available for this component"))) : (React.createElement(Alert, { severity: 'error' },
            "Component \"",
            configureComponent.type,
            "\" not found.")),
        React.createElement("div", { className: 'bottom' },
            React.createElement(SiteConfigDeleteComponent, { component: configureComponent })))) : (React.createElement("div", { className: 'config-zero-state' },
        React.createElement(Typography, { variant: 'overline' }, "Select a component to edit")))));
};
export default SiteConfigurePanel;
//# sourceMappingURL=SiteConfigurePanel.js.map